import {Component, forwardRef, Inject, Injector} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalResult} from "../model/common.model";
import {DomSanitizer, SafeHtml, SafeUrl} from "@angular/platform-browser";
import {SessionService} from "../services/session.service";

@Component({
  templateUrl: 'DlgErrorMessage.html',
})
export class DlgErrorMessage {


  title: string;
  message: string;
  messageClass='horarius-red';
  messageHtml: SafeHtml;
  stackString : string;
  stackStringVisible= false;
  helpAvailable = false;
  urlHelpFr = '';
  urlHelpOther = '';
  urlHelpFrSafe: SafeUrl;
  urlHelpOtherSafe: SafeUrl;
  urlLabel: string;

  constructor(
              @Inject(forwardRef(() => DomSanitizer)) protected domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => NgbActiveModal)) public activeModal: NgbActiveModal,
              @Inject(forwardRef(() => SessionService)) public session: SessionService,
              private injector: Injector){


  }

  populate(title: string, msg: string, msgCls?: string, html?: SafeHtml, stackString?: string){

    this.title = title;
    this.message = msg;
    if (msgCls){
      this.messageClass = msgCls;
    }
    if (html){
      this.messageHtml = html;
    }
    if (stackString){
      this.stackString = stackString;
    }
  }

  populateMore(params:DlgErrorParams){

    this.title = params.title;
    this.message = params.msg;
    if (params.msgCls){
      this.messageClass = params.msgCls;
    }
    if (params.html){
      this.messageHtml = params.html;
    }
    if (params.stackString){
      this.stackString = params.stackString;
    }

    if (params.helpAvailable===true){
      this.helpAvailable = true;
      this.urlLabel = params.urlLabel;

      this.urlHelpFr = params.urlHelpFr;
      this.urlHelpOther = params.urlHelpOther;

      // this.urlHelpFrSafe = this.domSanitizer.bypassSecurityTrustUrl(params.urlHelpFr);
      // this.urlHelpOtherSafe = this.domSanitizer.bypassSecurityTrustUrl(params.urlHelpOther);


      this.urlHelpFrSafe = this.domSanitizer.bypassSecurityTrustUrl(params.urlHelpFr);
      this.urlHelpOtherSafe = this.domSanitizer.bypassSecurityTrustUrl(params.urlHelpOther);
    }

  }

  onValidate(){
    this.activeModal.close(ModalResult.YES);
  }

  onClose(){
    this.activeModal.close(ModalResult.CANCEL);
  }


}

export class DlgErrorParams{

  title: string;
  msg: string;
  msgCls?: string;
  html?: SafeHtml;
  stackString?: string;

  helpAvailable = false;
  urlHelpFr?: string;
  urlHelpOther?: string;
  urlLabel?: string;

}
